import { X, Download } from 'lucide-react';

interface LightboxProps {
  url: string;
  onClose: () => void;
  onDownload?: () => void;
}

export const Lightbox: React.FC<LightboxProps> = ({ url, onClose, onDownload }) => {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md animate-fade-in"
      onClick={onClose}
    >
      <div className="relative max-w-5xl max-h-screen p-4 w-full h-full flex items-center justify-center">
        <img
          src={url}
          className="max-w-full max-h-full object-contain shadow-2xl rounded-lg"
          alt="Fullscreen preview"
          onClick={(e) => e.stopPropagation()}
        />
        
        {/* Control Buttons */}
        <div className="absolute top-4 right-4 flex items-center gap-2">
          {onDownload && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDownload();
              }}
              className="p-2 bg-white/10 hover:bg-primary text-white rounded-full backdrop-blur-sm transition-colors"
              title="Herunterladen"
            >
              <Download className="w-6 h-6" />
            </button>
          )}
          <button
            onClick={onClose}
            className="p-2 bg-white/10 hover:bg-white/20 text-white rounded-full backdrop-blur-sm transition-colors"
            title="Schließen"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
};
